/* eslint-disable import/prefer-default-export */
export const ItemTypes = {
  GOAL_LEVEL1: 'goal-level1',
};
